<template>
  <div>
    <Modal modal_size="modal-md" @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">Sent Invitations</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <!-- VERIFY TEACHER MODAL -->
        <div class="verify-teacher-modal">
          <div class="verify-teacher-top">
            <!-- ERROR ALERT -->
            <div
              style="position: relative; top: -10px; margin-bottom: -8px"
              v-if="show_processing"
            >
              <div
                class="display-processing color_white_bg rounded-5 w-100 d-flex justify-content-start align-items-center mb-3 p-2"
              >
                <div class="avatar">
                  <span
                    class="font-20 brand_accent flex-center mr-2"
                    :class="alert_icon"
                  ></span>
                </div>
                <div class="text color_grey_dark font-14">{{ alert_text }}</div>
              </div>
            </div>

            <!-- <div class="d-flex justify-content-end align-items-center nowrap">
           
              <div class="approve-all font-weight-500 font-14 brand_accent pointer">
                <span class="icon-swap mr-2 font-18"></span> Resend All
              </div>

              <div class="decline-all font-weight-500 font-14 brand_tonic pointer">
                <span class="icon-decline font-18 mr-2"></span> Cancel All
              </div>
            </div>-->
          </div>

          <!-- LOADER -->
          <div
            class="loader d-flex justify-content-center align-items-center my-4"
            v-if="invited_teachers.length < 1"
          >
            <div class="avatar avatar_md">
              <span
                class="icon-dotted-spinner flex-center font-24 border_grey-dark animate mr-3"
              ></span>
            </div>
            <div class="text color_grey_dark font-14-5">
              Loading Invitations ....
            </div>
          </div>
          <!-- LOADER -->

          <!-- VEIFICATION BLOCK COMPONENT -->
          <VerifyTeacherCard
            :id="Number(teacher.id)"
            :fullname="teacher.receiver_name"
            :class_name_id="Number(teacher.receiver_class)"
            :class_subject="teacher.subjects"
            :verify_type="false"
            v-for="(teacher, index) in invited_teachers"
            :key="index"
            @resend-invitation="resendInvitation($event)"
            @cancel-invitation="cancelInvitation($event)"
          ></VerifyTeacherCard>
          <!-- VEIFICATION BLOCK COMPONENT -->
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";
import VerifyTeacherCard from "@/components/schoolComps/dashboard/teacher/VerifyTeacherCard";
import { setTimeout } from "timers";

export default {
  name: "VerifyTeacherModal",

  components: {
    Modal,
    VerifyTeacherCard,
  },

  created() {
    this.getInvitedList();
  },

  data() {
    return {
      show_processing: false,
      alert_icon: "icon-dotted-roller animate",
      alert_text: "Updating, please wait...",
      invited_teachers: [],
    };
  },

  watch: {
    invited_teachers: "closeModalifEmpty",
  },

  methods: {
    ...mapActions([
      "getInvitedTeacherList",
      "resendTeacherInvitation",
      "cancelTeacherInvitation",
    ]),

    closeModalifEmpty() {
      if (this.invited_teachers.length === 0) {
        let dialog_data = {
          msg: "No more invited teachers",
          type: "success",
        };
        this.$emit("showAlertCard", dialog_data);
        this.$emit("closeTriggered");
      }
    },

    getInvitedList() {
      this.getInvitedTeacherList()
        .then((response) => {
          if (response.code === 200) this.invited_teachers = response.data;

          this.invited_teachers.reverse();
        })
        .catch((err) => console.log(err));
    },

    resendInvitation(id) {
      this.show_processing = true;
      this.alert_text = "Resending invitation";

      this.resendTeacherInvitation(id)
        .then((response) => {
          // HANDLE A 200 RESPONSE CODE
          if (response.code === 200) {
            setTimeout(() => {
              this.show_processing = true;
              this.alert_icon = "icon-accept";
              this.alert_text = "Invitation resent successfully";
              this.$emit("closeTriggered");
            }, 2000);

            setTimeout(() => {
              this.show_processing = false;
            }, 4000);
          }
          // HANDLE A NON 200 RESPONSE
          else {
            setTimeout(() => {
              this.show_processing = true;
              this.alert_icon = "icon-decline";
              this.alert_text = "An error occured while resending invitation";
            }, 2000);

            setTimeout(() => {
              this.show_processing = false;
              this.getInvitedList();
            }, 4000);
          }
        })
        .catch((err) => console.log(err));
    },

    cancelInvitation(id) {
      this.show_processing = true;
      this.alert_text = "Cancelling invitation";

      this.cancelTeacherInvitation(id)
        .then((response) => {
          // HANDLE A 200 RESPONSE CODE
          if (response.code === 200) {
            setTimeout(() => {
              this.show_processing = true;
              this.alert_icon = "icon-accept";
              this.alert_text = "Invitation cancelled successfully";
            }, 2000);

            setTimeout(() => {
              this.show_processing = false;
              this.getInvitedList();
            }, 4000);
          }
          // HANDLE A NON 200 RESPONSE
          else {
            setTimeout(() => {
              this.show_processing = true;
              this.alert_icon = "icon-decline";
              this.alert_text = "An error occured while cancelling invitation";
            }, 2000);

            setTimeout(() => {
              this.show_processing = false;
            }, 4000);
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
// VERIFY TEACHER MODAL
.verify-teacher-modal {
  .verify-teacher-top {
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid $border_grey;

    .approve-all,
    .decline-all {
      span {
        position: relative;
        top: 2px;
      }
      transition: color 0.3s ease-in-out;
    }

    .approve-all {
      margin-right: 32px;

      &:hover {
        color: darken($brand_accent, 30%) !important;
      }
    }

    .decline-all {
      &:hover {
        color: darken($brand_tonic, 30%) !important;
      }
    }
  }
}
</style>
